export default __webpack_public_path__ + "static/media/intheOffice-sample-people-upload.2a6913cb.csv";